import React from "react";
import TopPromo from "@/components/site/TopPromo";
import Nav from "@/components/site/Nav";

export default function FixedHeader() {
  return (
    <div data-testid="fixed-header" className="fixed top-0 inset-x-0 z-50">
      {/* White urgency strip pinned to the very top */}
      <TopPromo />
      {/* Main nav on the orange canvas below */}
      <Nav />
    </div>
  );
}
